module.exports = __webpack_public_path__ + "static/media/classrooms-menu.c14faf99.svg";